import { Body } from '@assembly-js/design-system';
import clsx from 'clsx';

import { ActivationChecklist } from './ActivationChecklist';
import { ChecklistWrapper } from './ChecklistWrapper';
import { StatusMarkIcon } from './StatusMarkIcon';
import { StudioChecklistTaskStatus } from './studioChecklist';
import { useStudioChecklist } from './useStudioChecklist';

export const InternalChecklist = () => {
  const checklist = useStudioChecklist();
  const {
    tasks,
    completionPct,
    isCollapsed,
    toggleCollapse,
    onTaskClick,
    shouldRender,
    allTasksCompleted,
  } = checklist;

  if (checklist.isActivation) {
    return <ActivationChecklist checklist={checklist} />;
  }

  if (!shouldRender) {
    return null;
  }

  return (
    <ChecklistWrapper
      completionPct={completionPct}
      isCollapsed={isCollapsed}
      onToggleCollapse={toggleCollapse}
      isComplete={allTasksCompleted}
    >
      <div className="flex flex-col">
        {tasks.map((task) => {
          const isDone = task.status === StudioChecklistTaskStatus.Done;
          return (
            <div
              key={task.id}
              className="box-border flex w-full flex-col overflow-hidden bg-white"
            >
              <button
                type="button"
                onClick={() => onTaskClick(task.id)}
                disabled={isDone}
                className={clsx(
                  'box-border flex w-full appearance-none items-center gap-1.5 rounded border-0 bg-transparent px-2 py-1.5 text-left outline-hidden',
                  isDone
                    ? 'cursor-default'
                    : 'transition-colors hover:cursor-pointer hover:bg-gray-100 active:bg-gray-150',
                )}
              >
                <span className="flex shrink-0 items-center justify-center">
                  <StatusMarkIcon status={task.status} />
                </span>
                <Body
                  tag="span"
                  size="xs"
                  className={clsx('m-0! min-w-0 flex-1 leading-5!', {
                    'text-secondary line-through': isDone,
                    'text-copilot-green-800':
                      task.status === StudioChecklistTaskStatus.InProgress,
                    'text-black-heading':
                      task.status === StudioChecklistTaskStatus.Todo,
                  })}
                >
                  {task.label}
                </Body>
              </button>
            </div>
          );
        })}
      </div>
    </ChecklistWrapper>
  );
};
